import { Apis } from "../../lib/Apis";

export const useBuyPlans = () => {
    const getPlans = async (setPlansData) => {
        try {
            const response = await Apis.getBuyPlans();
            setPlansData(response.data.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching plans:", error);
            throw error;
        }
    }
    const getPlansById = async (id, setGetByIdData) => {
        try {
            const response = await Apis.getBuyPlansById(id);
            setGetByIdData(response.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching plan by ID:", error);
            throw error;
        }
    }
    const createPlan = async (data) => {
        try {
            const response = await Apis.addBuyPlan(data);
            return response.data;
        } catch (error) {
            console.error("Error creating plan:", error);
            throw error;
        }
    }
    const updatePlan = async (id, data) => {
        try {
            const response = await Apis.updateBuyPlan(id, data);
            return response.data;
        } catch (error) {
            console.error("Error updating plan:", error);
            throw error;
        }
    }
    const deletePlan = async (id) => {
        try {
            const response = await Apis.deleteBuyPlan(id);
            return response.data;
        } catch (error) {
            console.error("Error deleting plan:", error);
            throw error;
        }
    }
    const associateBuyPlanToHouseDesing = async (data) => {
        try {
            const response = await Apis.associateBuyPlanToHouseDesing(data);
            return response;
        } catch (error) {
            console.error("Error associating plan to house design:", error);
            throw error;
        }
    }
    const getBuyPlanByHouseDesignId = async (buyPlanId, setBuyPlanByHouseDesignIdData) => {
        try {
            const response = await Apis.getBuyPlanByHouseDesignId(buyPlanId);
            setBuyPlanByHouseDesignIdData(response.data.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching buy plan by house design ID:", error);
            throw error;
        }
    }
    const getExcludedHousePlans = async (buyPlanId, setExcludedHousePlansData) => {
        try {
            const response = await Apis.getExcludedHousePlans(buyPlanId);
            setExcludedHousePlansData(response.data.data);
            return response;
        } catch (error) {
            console.error("Error fetching excluded house plans:", error);
            throw error;
        }
    }
    const getBuyPlanById = async (buyPlanId, setBuyPlanByIdData) => {
        try {
            const response = await Apis.getBuyPlansById(buyPlanId);
            setBuyPlanByIdData(response.data.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching buy plan by ID:", error);
            throw error;
        }
    }
    const updateBuyAssociatedPlan = async (body) => {
        try {
            const response = await Apis.updateBuyAssociatedPlan(body);
            return response.data;
        } catch (error) {
            console.error("Error while updating")
            return error
        }
    }
    const deleteBuyPlanFromHouseDesign = async (id) => {
        try {
            const response = await Apis.deleteBuyPlanFromHouseDesign(id);
            return response.data;
        } catch (error) {
            console.error("Error deleting buy plan:", error);
            throw error;
        }
    }
    const getPurchasedHouseDesigns = async (params = {}, setPurchasedHouseDesignsData) => {
        try {
            const response = await Apis.getPurchasedHouseDesigns(params);
            const payload = response.data;
            if (typeof setPurchasedHouseDesignsData === "function") {
                setPurchasedHouseDesignsData(payload.data);
            }
            return payload;
        } catch (error) {
            console.error("Error fetching purchased house designs:", error);
            throw error;
        }
    };
    const getPurchasedHouseDesignById = async (id, setPurchasedHouseDesignByIdData) => {
        try {
            const response = await Apis.getPurchasedHouseDesignById(id);
            const row = response.data.data;
            if (typeof setPurchasedHouseDesignByIdData === "function") {
                setPurchasedHouseDesignByIdData(row);
            }
            return response.data;
        } catch (error) {
            console.error("Error fetching purchased house design by ID:", error);
            throw error;
        }
    };
    const verifyPurchasedHouseDesignPayment = async (purchaseId, paymentStatus) => {
        try {
            const response = await Apis.verifyPurchasedHouseDesignPayment(purchaseId, {
                paymentStatus,
            });
            return response;
        } catch (error) {
            console.error("Error verifying purchased house design payment:", error);
            throw error;
        }
    };
    return {
        getPlans,
        getPlansById,
        createPlan,
        updatePlan,
        deletePlan,
        associateBuyPlanToHouseDesing,
        getBuyPlanByHouseDesignId,
        getExcludedHousePlans,
        getBuyPlanById,
        updateBuyAssociatedPlan,
        deleteBuyPlanFromHouseDesign,
        getPurchasedHouseDesigns,
        getPurchasedHouseDesignById,
        verifyPurchasedHouseDesignPayment,
    };
}